/**
 * lp-v3 GRID SYSTEM — the single source of truth for the landing layout. Every section keeps a
 * 16px (mobile) / 30px (desktop) gutter to the screen edge; the shared max-width column centres the
 * content, so on large screens everything aligns:
 *
 *   screen edge                                                screen edge
 *   │← 30px →┌──────────── card background ─────────────┐← 30px →│
 *   │         │← 64px pad →│  CONTENT (max 1320) │← 64px pad →│   │
 *   │← 30px →│  CONTENT (max 1320, centred)  │← 30px →│           ← section without bg
 *
 * - Sections WITH a background/border use `cardSection` gutter + `cardPad` inside the card.
 * - Sections WITHOUT use `contentSection` — the same 16/30px edge.
 * - Deliberate exceptions: footer + above-footer (full width), logos + case-studies marquees
 *   (full width with gradient fades), the statement card (full-screen scroll takeover), and the
 *   nav (full-width background, grid-aligned content).
 */
export const LP_GRID = {
    /** Gutter for CARD sections (background/border): 16px mobile / 30px desktop. */
    cardSection: 'px-4 md:px-[30px]',
    /** Inner padding of a card: 16px mobile / 64px desktop — always. */
    cardPad: 'p-4 md:p-[64px]',
    /** Gutter for content-only sections — same 16/30px edge as the card sections. */
    contentSection: 'px-4 md:px-[30px]',
    /** The shared, centred content column. */
    content: 'mx-auto w-full max-w-[1320px]',
    /**
     * Full-height "stage" — a section CARD sized to fill exactly one viewport below the fixed 64px nav,
     * matching the hero: 100svh − 64px (nav) − 80px (the section's 40px top+bottom padding) = 100svh −
     * 144px, clamped so it never collapses or grows absurdly. Apply to the CARD element (so the whole
     * card, including its own padding, is one viewport) together with `md:flex md:flex-col` and give the
     * inner content a `md:flex-1` so it fills the card — simple centre, or Rule 6 · the elastic middle.
     * `md`-up only; mobile keeps its natural, content-driven height. From the designers' Scale System
     * (scale-lab.html): the AIR grows, not the art. Card sections use `py-[60px] md:py-[40px]` to match.
     */
    stageMinH: 'md:min-h-[clamp(520px,calc(100svh_-_144px),1080px)]',
} as const
